import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useSubmitPartnerEventMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const submitEvent = api.submitEvent;
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async (variables) => {
      if (!submitEvent) {
        throw new Error('Submit is not available for this account');
      }

      const eventId = typeof variables === 'object' ? variables?.eventId : variables;
      const payload =
        typeof variables === 'object' && variables?.payload
          ? variables.payload
          : { status: 'submit' };

      if (!eventId) {
        throw new Error('Event id is required to submit');
      }

      const result = await submitEvent(eventId, payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to submit event');
      }
      return result.data;
    },
    onSuccess: async (data, variables, context) => {
      const eventId = typeof variables === 'object' ? variables?.eventId : variables;
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (eventId) {
        await queryClient.invalidateQueries({ queryKey: queryKeys.detail(eventId) });
      }
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
